// extracted by mini-css-extract-plugin
module.exports = {"inline":"inline--2EO8r","group":"group--1b_Hc"};